import { createRequest } from './createRequest';
import { parseResponse } from './parseResponse';

export async function getConfig() {
  return await (process.env.NODE_ENV === 'production'
    ? fetch(createRequest(`/config/`, 'GET')).then(parseResponse)
    : Promise.resolve({
        checkoutUrl: {
          se: process.env.REACT_APP_CHECKOUT_URL_SE,
          dk: process.env.REACT_APP_CHECKOUT_URL_DK,
          fi: process.env.REACT_APP_CHECKOUT_URL_FI,
          no: process.env.REACT_APP_CHECKOUT_URL_NO
        }
      }));
}
